import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";

const OrgProfile = () => {
  const [data, setData] = useState();

  const { sendRequest: getOrg } = useHttp();

  const getData = () => {
    getOrg(
      {
        url: `/api/organisation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        // //console.log(res);
        setData(res);
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <ol className="breadcrumb float-sm-center">
                  <li className="breadcrumb-item">Organization Profile</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4">
                {/* Profile Image */}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Organization Information</h3>
                  </div>

                  <div className="card-body box-profile">
                    <br />
                    <div className="text-center">
                      <img
                        className="profile-user-img img-fluid img-circle"
                        src={`${process.env.REACT_APP_FILE_URL}${
                          data && data.organizationIcon
                        }`}
                        alt="Profile"
                      />
                    </div>
<br/>
                    <ul className="list-group list-group-unbordered mb-3">
                      <li className="list-group-item">
                        <b>Organization Code</b>{" "}
                        <div className="float-right">
                          {" "}
                          {data && data.orgCode}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <b>Organization Name</b>{" "}
                        <div className="float-right">
                          {data && data.orgName}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <b>Contact Person Name</b>{" "}
                        <div className="float-right">
                          {data && data.contactPerson}
                        </div>
                      </li>
                     
                    </ul>
                  </div>
                  <br />
                  {/* /.card-body */}
                </div>
                {/* /.card */}
                {/* About Me Box */}
              </div>
              <div className="col-md-4 ">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Contact Information</h3>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    <strong>
                      <i className="fas  fa-solid fa-address-card mr-1" />{" "}
                      Contact Number
                    </strong>
                    <p className="text-muted"> {data && data.phoneNumber}</p>
                    <hr />
                  
                    <strong>
                      <i className="fas fa-solid fa-envelope mr-1"></i>Organization Email
                    </strong>
                    <p className="text-muted">
                      <span className="tag tag-danger">
                        {" "}
                        {data && data.orgEmail}
                      </span>
                    </p>
                    <hr />
                    <strong>
                      <i className="fas fa-map-marker-alt mr-1" />
                    Address
                    </strong>
                    <p className="text-muted">
                      {" "}
                      {data &&
                        data.address + " " +data.city }
                        <br/>
                        {data &&
                        data.state + " " +data.country + " " + data.zipCode}

                    </p>
                    <hr />
                  
                  <strong>
                    <i className="fas fa-solid fa-envelope mr-1"></i>Contact Person Email
                  </strong>
                  <p className="text-muted">
                    <span className="tag tag-danger">
                      {" "}
                      {data && data.contactPersonEmail}
                    </span>
                  </p>
                  <hr/>
                  <strong>
                      <i className="fas  fa-solid fa-address-card mr-1" />{" "}
                      Contact Person Phone No
                    </strong>
                    <p className="text-muted"> {data && data.contactPersonPhoneNo}</p>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OrgProfile;
